import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class TranslationDatabaseService {

  constructor(
    private _httpClient: HttpClient,
  ) {
  }

  async getList() {
    return this._httpClient.get('/translation').toPromise();
  }

  async updateField(id: number, data: any = {}) {
    return this._httpClient.put('/translation/' + id, data).toPromise();
  }

  async createField(data: any = {}) {
    return this._httpClient.post('/translation', data).toPromise();
  }

  async deleteField(id: number) {
    return this._httpClient.delete('/translation/' + id).toPromise();
  }
}
